module.exports = __webpack_public_path__ + "img/google.0f2c6ce5.png";